module.exports = __webpack_public_path__ + "static/media/Requests.20df0e53.svg";